import PropTypes from "prop-types";
import { CASE_STUDY_CARD_PROP_TYPES } from "./CaseStudyCard.types";

/**
 * @typedef {Object} CreatorCaseStudiesProps
 * @property {import('./CaseStudyCard.types').CaseStudyCardData[]} [cards]
 * @property {string} [containerClassName]
 */

export const CREATOR_CASE_STUDIES_PROPS = {
  cards: PropTypes.arrayOf(CASE_STUDY_CARD_PROP_TYPES),
  containerClassName: PropTypes.string,
};
